import React from 'react';
import {GatsbyImage, StaticImage} from 'gatsby-plugin-image';

import Button from './button';
import Container from './container';
import Heading from './heading';
import Text from './text';

import {
  heroImageWrapperStyle,
  heroImageWrapperStyle2,
  heroImageStyle,
  heroImageStyle2,
  containerStyle,
  leftWrapper,
  headingStyle,
  descriptionStyle,
  heroButtonStyle,
} from './hero.module.css';

const Hero = ({
  heroHeading,
  heroDescription,
  heroButtonText,
  heroButtonTarget,
  appJobTypes,
  image,
}) => {
  return (
    <>
      <Container variant="full" className={containerStyle}>
        <div className={leftWrapper}>
          <Heading as="h1" className={headingStyle}>
            {heroHeading}
          </Heading>
          <Text className={descriptionStyle}>
            {heroDescription && heroDescription}
          </Text>
          {heroButtonText && (
            <Button
              appJobTypes={appJobTypes}
              target={heroButtonTarget}
              className={heroButtonStyle}
            >
              {heroButtonText}
            </Button>
          )}
        </div>
        {image ? (
          <GatsbyImage
            image={image.asset.gatsbyImageData}
            alt={image.alt}
            className={heroImageWrapperStyle2}
            imgClassName={heroImageStyle2}
            layout="fullWidth"
            loading="eager"
          />
        ) : (
          <StaticImage
            src="../images/hero--front.png"
            alt="Löydä tekijä remontille UrakkaDiilistä"
            className={heroImageWrapperStyle}
            imgClassName={heroImageStyle}
            breakpoints={[768, 992, 1200]}
            layout="fullWidth"
            style={{position: 'absolute'}}
            loading="eager"
          />
        )}
      </Container>
    </>
  );
};

export default Hero;
